export default "__VITE_ASSET__PinIb6Nv__"